module.exports = __webpack_public_path__ + "img/home-bg-en.a322c120.png";